import { render, staticRenderFns } from "./PatientCreateOrderAction.vue?vue&type=template&id=8ff0b42a&scoped=true&"
import script from "./PatientCreateOrderAction.vue?vue&type=script&lang=js&"
export * from "./PatientCreateOrderAction.vue?vue&type=script&lang=js&"
import style0 from "./PatientCreateOrderAction.vue?vue&type=style&index=0&id=8ff0b42a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff0b42a",
  null
  
)

export default component.exports